import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	restrictedProject: {
		id: 'issue-field-atlas-project-common.restricted.restricted-project.non-final',
		defaultMessage: 'Restricted project',
		description: 'Text to indicate that a given project is restricted',
	},
});
